export default "__VITE_ASSET__Bv0vHFr2__"